import script from "./multilingual.vue?vue&type=script&lang=ts&setup=true"
export * from "./multilingual.vue?vue&type=script&lang=ts&setup=true"

import "./multilingual.vue?vue&type=style&index=0&id=848b1796&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-848b1796"]])

export default __exports__